// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isIE11(navigator: any): boolean {
    return Boolean((/Trident\/7\./).test(navigator.userAgent));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isiOS12(navigator: any): boolean {
    return Boolean((/iPad|iPhone|iPod/ && /Version\/12\./).test(navigator.userAgent));
}
